export const locale = {
    lang: 'en',
    data: {
        'MODULE': {
            'TITLE': 'Log Entries'
        }
    }
};


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/log.entries/i18n/en.ts